$(function() {
    const free_shipping_threshold_eu = Math.round(41.27 * parseFloat(Shopify.currency.rate));
    const shipping_cost_eu = Math.round(238 * parseFloat(Shopify.currency.rate));
    const free_shipping_threshold_au = 100;
    const free_shipping_threshold_ca = 100;
    const shipping_cost_au = 9.00;
    const shipping_cost_ca = 8.00;

    function catchRequest(url, callback) {
        var f = fetch;
        window.fetch = function() {
            const request = f.apply(window, arguments);
            if (arguments[0] === url) {
                request.then(callback);
            }
            return request;
        }
    }

    function renderElements(cart_value) {
        $('.shipping-progress').hide();
        $('.free-shipping-badge').hide();
        $('.cw-cart-drawer-subtotals .discount-row').hide();

        if (['european-union', 'germany', 'france', 'spain', 'italy'].includes(cw_market_handle)) {
            console.log(cart_value, free_shipping_threshold_eu);
            if (cart_value < free_shipping_threshold_eu) {
                const money_left = free_shipping_threshold_eu - cart_value;
                const percent_left = (cart_value * 100) / free_shipping_threshold_eu;
                $('.shipping-progress').show();
                $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
                $('.shipping-progress span').html(CW_formatMoney(money_left * 100));
                $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
                $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_eu));
            } else {
                $('.free-shipping-badge').show();
                $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
            }
            $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();
            $('.cw-cart-drawer-subtotals .discount-row.tshipping-number').text();
        } else if (['australia'].includes(cw_market_handle)) {
            console.log(cart_value, free_shipping_threshold_au);
            if (cart_value < free_shipping_threshold_au) {
                const money_left = free_shipping_threshold_au - cart_value;
                const percent_left = (cart_value * 100) / free_shipping_threshold_au;
                $('.shipping-progress').show();
                $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
                $('.shipping-progress span').html(CW_formatMoney(money_left * 100));
                $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
                $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_au * 100));
            } else {
                $('.free-shipping-badge').show();
                $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
            }
            $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();
            $('.cw-cart-drawer-subtotals .discount-row.tshipping-number').text();
        } else if (['canada'].includes(cw_market_handle)) {
            console.log(cart_value, free_shipping_threshold_ca);
            if (cart_value < free_shipping_threshold_ca) {
                const money_left = free_shipping_threshold_ca - cart_value;
                const percent_left = (cart_value * 100) / free_shipping_threshold_ca;
                $('.shipping-progress').show();
                $('.shipping-progress .progress-bar-value').css('width', percent_left + '%');
                $('.shipping-progress span').html(CW_formatMoney(money_left * 100));

                $('.cw-cart-drawer-subtotals .discount-row.shipping-number').show();
                $('.cw-cart-drawer-subtotals .discount-row.shipping-number .value').text(CW_formatMoney(shipping_cost_ca * 100));
            } else {
                $('.free-shipping-badge').show();
                $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
            }
            // Removed: $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();
            $('.cw-cart-drawer-subtotals .discount-row.tshipping-number').text();
        } else if (['gb', 'united-states-2'].includes(cw_market_handle)) {
            $('.free-shipping-badge').show();
            $('.cw-cart-drawer-subtotals .discount-row.shipping-free').show();
            if (cw_market_handle === 'united-states-2') {
                $('.cw-cart-drawer-subtotals .discount-row.taxes-n-duties').show();
            }
        } else {
            $('.cw-cart-drawer-subtotals .discount-row.shipping-calculated').show();
        }
    }

    catchRequest('/cart.js', function(response) {
        response.clone().json().then(function(data) {
            renderElements(parseFloat((data.items_subtotal_price / 100.0).toFixed(2)));
        });
        return response;
    });

    fetch('/cart.js');
});